unit TranslationType;
{

/* Initial. */

}
interface

uses
  JS,
  TermListType;

type
  TTranslationType = class
  private
    fLanguage: String;
    fTermList: TTermListType;
  public
    property Language: String read fLanguage;
    property TermList: TTermListType read fTermList;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TTranslationType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if (String_JSON <> '[]') and (String_JSON <> 'null') then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fLanguage := String(JSObject_Type['language']);
    fTermList := TTermListType.Create(TJSJSON.stringify(JSObject_Type['termList']));
  end;
end;

end.
